import { faShareAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { CSVLink } from "react-csv";
import "../../style";
import { formateHeader, formateRows } from "../../utils/csvUtils";
import { getFullDateTime } from "../../utils/DateFormatter";

export default function DownloadAsCSV(props) {
  const { dataRows = [], headerRows = [] } = props;
  const formatedHeader = formateHeader(headerRows);
  const formatedRows = formateRows(dataRows);

  return (
    <div>
      <CSVLink
        filename={`NTRAC_Report_${getFullDateTime(new Date(), 6)}.csv`}
        data={formatedRows}
        headers={formatedHeader}
        style={{ color: "#00bc84" }}
      >
        <div>
          <FontAwesomeIcon icon={faShareAlt} />
          <span>Export</span>
        </div>
      </CSVLink>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Common/DownloadAsCSV.js